/**
 * 缓存说明:虚拟变量缓存
 */
import vm from './storeTools.js'
import variableApi from '../components/api/variableApi.js'
import deviceStore from '@/cache/deviceStore.js'
var basestate = {
	deviceNoToVariableTree: {
		//虚拟设备所具有的虚拟变量树
	},
	//电流1是调试用的，记得删掉
	// powerApptypeGroup: [{
	// 	id: 6,//6
	// 	name: '电压谐波畸变率'
	// }, {
	// 	id: 32,
	// 	name: '电流不平衡度'
	// }, {
	// 	id: 34,
	// 	name: '电压不平衡度'
	// }, {
	// 	id: 35,
	// 	name: '电压偏差'
	// }, {
	// 	id: 41,
	// 	name: '频率偏差'
	// }, {
	// 	id: -3,
	// 	name: '奇数谐波含有率',
		
	// }, {
	// 	id: -2,
	// 	name: '偶数谐波含有率',
	// 	next:[{
	// 		id:19,
	// 		name:'A相电流偶次谐波'
	// 	},{
	// 		id:21,
	// 		name:'B相电流偶次谐波'
	// 	},{
	// 		id:23,
	// 		name:'C相电流偶次谐波'
	// 	},{
	// 		id:25,
	// 		name:'A相电压偶次谐波'
	// 	},{
	// 		id:27,
	// 		name:'B相电压偶次谐波'
	// 	}]
	// }],
	powerApptypeGroup: [ {
		id: 32,
		value: "voltageUnbalance",
		name: '电流不平衡度'
	}, {
		id: 34,
		value: "currentUnbalance",
		name: '电压不平衡度'
	}, {
		id: 41,
		value: "frequencyDeviation",
		name: '频率偏差'
	}, {
		id: 6,
		value: "voltageDistortionRate",
		name: '电压谐波畸变率'
	}, {
		id: -3,
		value: "oddHarmonicInclusionRate",
		name: '奇数谐波含有率'
	}, {
		id: -2,
		value: "evenHarmonicInclusionRate",
		name: '偶数谐波含有率'
	}],
	isDevice:true,//是否为设备
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getVariableTree(state, getters) {
			/**
			 * 获取设备的虚拟变量树，可通过apptype或者apptypegroup过滤
			 * typeNos和typeGroupNos参数为数组，二选一，typeNos优先级高
			 */
			return (deviceNo, typeNos, typeGroupNos) => {
				//先判断他传入的是否为设备不是设备就不查询
				/*store.commit("diguiDevice",{list:[deviceStore.getters.getReadDeviceTree],deviceNo:deviceNo})*/
				var list = state.deviceNoToVariableTree['no' + deviceNo]
				if (list == undefined) {
					//需要先获取所有数据
					store.commit("getVariableTree", deviceNo)
					return []
				}
				list = copy(list)
				if (!isempty(typeNos)) {
					//按类型过滤
					list.forEach(item => {
						item.next = item.next.filter(i => {
							return typeNos.includes(i.typeNo)
						})
						return item
					})
					return list.filter(item => {
						return !isempty(item.next)
					})
				} else if (!isempty(typeGroupNos)) {
					//按类型组过滤
					return list.filter(item => {
						return typeGroupNos.includes(item.no)
					})
				}
				return list
			}
		},
		getTargetApptypeVariableList(state,getters){
			//获取设备下指定类型的变量列表
			return (deviceNo,typeNo)=>{
				var vList = getters.getVariableTree(deviceNo)
				var list = []
				for (var i = 0, len = vList.length; i < len; i++) {
					var item = vList[i]
					list.addAll(item.next.filter(it=>it.typeNo == typeNo))
					if (list.length>0) {
						break
					}
				}
				return list
			}
		}

	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		 getVariableTree(state, deviceNo) {
			if (isempty(deviceNo)) {
				return
			}
	
			 variableApi.getVariableTree(deviceNo, respon => {
				vm.Vue.set(state.deviceNoToVariableTree, 'no' + deviceNo, respon)
			})
		},
		diguiDevice(state,getters){
			getters.list.forEach(item=>{
				if(item.no==getters.deviceNo){
					if(item.type=='virtualDevice'){
						state.isDevice=true
					}else{
						state.isDevice=false
					}
				}else{
					if(!isempty(item.next)){
						store.commit("diguiDevice", {list:item.next,deviceNo:getters.deviceNo})
					}
				}
			})
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
